import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a77b3fde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "verify-row"
};
const _hoisted_2 = {
    key: 0,
    class: "verify-row"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "verify-text" }, "未认证", -1));
const _hoisted_4 = {
    key: 1,
    class: "verify-row"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "教育认证", -1));
const _hoisted_6 = { class: "expried" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "verify-text" }, "更新", -1));
const _hoisted_8 = {
    key: 1,
    class: "verify-row"
};
const _hoisted_9 = {
    key: 0,
    class: "verify-row"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "未认证", -1));
const _hoisted_11 = {
    key: 1,
    class: "verify-row"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "个人认证", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "verify-text" }, "企业认证", -1));
const _hoisted_14 = {
    key: 2,
    class: "verify-row"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "认证审核中", -1));
const _hoisted_16 = {
    key: 3,
    class: "verify-row"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "企业认证", -1));
import CloudTag from "@/components/CloudTag/index.vue";
import { VERIFY_TYPE_VALUE } from "@/types/personal";
import { isMobileDevice } from "@/utils";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    name: 'VerifyType',
    props: {
        verifyType: { default: 0 },
        isShow: { type: Boolean, default: false },
        canClick: { type: Boolean, default: true },
        type: { default: "personal" },
        data: { default: () => ({}) }
    },
    emits: ["personal"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const goPersonalVerify = () => {
            if (!props.canClick)
                return;
            emit("personal");
        };
        const goEnterpriseVerify = () => {
            if (isMobileDevice()) {
                router.push({
                    path: "/personal/enterpriseAuth"
                });
            }
            else {
                router.push({
                    path: "/personal/verify"
                });
            }
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (__props.type === 'edu')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (__props.verifyType === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_el_tooltip, {
                                content: "请先进行实名认证",
                                placement: "top",
                                disabled: !!__props.canClick
                            }, {
                                default: _withCtx(() => [
                                    (!__props.isShow)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["verify-button", { disabled: !__props.canClick }]),
                                            onClick: goPersonalVerify
                                        }, [
                                            _hoisted_3,
                                            _createVNode(_component_svg_icon, {
                                                "icon-class": __props.canClick ? 'arrow6' : 'arrow5',
                                                "class-name": __props.canClick ? 'arrow-icon' : 'arrow-icon not-allow'
                                            }, null, 8, ["icon-class", "class-name"])
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["disabled"])
                        ]))
                        : (__props.verifyType === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(CloudTag, {
                                    type: "success",
                                    class: "edu-style",
                                    icon: "edu"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_5
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(__props.data.edu_auth_expired_at?.split(" ")[0]) + "到期", 1),
                                (__props.data.edu_auth_update_enabled)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "verify-button",
                                        onClick: goPersonalVerify
                                    }, [
                                        _hoisted_7,
                                        _createVNode(_component_svg_icon, {
                                            "icon-class": "arrow6",
                                            "class-name": "arrow-icon"
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['未认证'] ||
                        __props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证审核不通过'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(CloudTag, {
                                class: "warning-style cursor",
                                type: "warning",
                                icon: "info2",
                                onClick: goPersonalVerify
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_10,
                                    _createVNode(_component_svg_icon, { "icon-class": "arrow90" })
                                ]),
                                _: 1
                            })
                        ]))
                        : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人认证'] ||
                            __props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人升级企业审核不通过'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(CloudTag, {
                                    class: "master-style",
                                    icon: "status_personal"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_12
                                    ]),
                                    _: 1
                                }),
                                (!__props.isShow)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "verify-button m-l-4",
                                        onClick: goEnterpriseVerify
                                    }, [
                                        _hoisted_13,
                                        _createVNode(_component_svg_icon, {
                                            "icon-class": "arrow6",
                                            "class-name": "arrow-icon"
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证待审核'] ||
                                __props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人升级企业待审核'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(CloudTag, {
                                        class: "warning-style",
                                        type: "warning"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_15
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证'])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createVNode(CloudTag, {
                                            class: "master-style",
                                            icon: "status_business"
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_17
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                ]));
        };
    }
});
